import { useElements, useStripe } from "@stripe/react-stripe-js";
import { confirmStripePayment, confirmStripeSetup } from "../lib/helpers/stripeWrappers";

export const successReturnUrl = `${window.location.origin}/welcome-onboard`;

const usePaymentAttempt = () => {
  const stripe = useStripe();
  const elements = useElements();

  const setupAttemptHandler = confirmStripeSetup(
    stripe,
    elements,
    successReturnUrl
  );

  const paymentAttemptHandler = confirmStripePayment(
    stripe,
    elements,
    successReturnUrl
  );

  return { setupAttemptHandler, paymentAttemptHandler };
};

export default usePaymentAttempt;
